import { useEffect, useState } from 'react'
import { Modal } from './ui/Modal'
import btnStyles from './ui/Button.module.css'
import { attachmentsApi } from '../api/attachments.api'
import type { Attachment } from '../api/types'

export function AttachmentPreviewModal({ attachment, onClose }: { attachment: Attachment; onClose: () => void }) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    let url: string | null = null
    fetch(attachmentsApi.downloadUrl(attachment.id), { credentials: 'include' })
      .then((res) => res.blob())
      .then((blob) => {
        if (cancelled) return
        url = URL.createObjectURL(blob)
        setObjectUrl(url)
      })
    return () => {
      cancelled = true
      if (url) URL.revokeObjectURL(url)
    }
  }, [attachment.id])

  return (
    <Modal
      title={attachment.originalName}
      onClose={onClose}
      size="lg"
      footer={
        <>
          <button className={[btnStyles.btn, btnStyles.ghost].join(' ')} onClick={onClose}>
            Schließen
          </button>
          <a href={attachmentsApi.downloadUrl(attachment.id)} className={[btnStyles.btn, btnStyles.primary].join(' ')}>
            Herunterladen
          </a>
        </>
      }
    >
      {objectUrl ? (
        <img src={objectUrl} alt={attachment.originalName} style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block', margin: '0 auto' }} />
      ) : (
        <span style={{ color: 'var(--text-muted)' }}>Lädt…</span>
      )}
    </Modal>
  )
}
